// initial state
import * as base from './base.js'
const baseName = '/admin/system/customer'

const customerList = baseName + '/list'//客户列表
const customerAdd = baseName + '/add'//客户列表
const customerEdit = baseName + '/edit'//客户列表




const obj = base.setBaseUrl('customer', baseName)
const obj1 = base.setBaseUrl('customerList',customerList )
const obj2 = base.setBaseUrl('customerAdd',customerAdd )
const obj3 = base.setBaseUrl('customerEdit',customerEdit )





// const obj2 = base.setBaseUrl('deviceTagsRecord', tagsRecordName)
const a = Object.assign(obj, obj1,obj2,obj3, {customerList,customerAdd,customerEdit})
export default a
